(function() {
  "use strict";

  angular.module("app").directive("cccDomainSelector", cccDomainSelector);

  function cccDomainSelector() {
    return {
      restrict: "EA",
      scope: false,
      controller: "DomainSelectorController"
    };
  }
})();
